const STORAGE_KEY = 'mms_sharedConfig';

const SHARED_KEYS = [
  'BackgroundColor',
  'ApplicationHeading',
  'ApplicationSubHeading',
  'ApplicationHeadingVideoInHome',
  'ApplicationSubHeadingVideoInHome',
  'WebCaatAuthWebUrl',
  'AuthCookieDomain',
  'LinkTvAnalys',
  'LinkOnlineAnalys',
  'LinkTotalanalys',
  'LinkVideoInHome',
  'LinkDataPortal',
  'MyOwnApplicationUrl'
];

/**
 * Extract shared keys from a full runtime config and save to localStorage.
 * Called after each app loads its runtime.json.
 * @param {Object} fullConfig - The full runtime.json object
 */
export function saveSharedConfig(fullConfig) {
  if (!fullConfig || typeof fullConfig !== 'object') return;
  try {
    const shared = {};
    SHARED_KEYS.forEach(key => {
      if (key in fullConfig) shared[key] = fullConfig[key];
    });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(shared));
  } catch { /* quota exceeded or private mode */ }
}

/**
 * Load cached shared config from localStorage.
 * @returns {Object|null} Cached shared config, or null if unavailable
 */
export function loadCachedSharedConfig() {
  try {
    const cached = localStorage.getItem(STORAGE_KEY);
    if (!cached) return null;
    const parsed = JSON.parse(cached);
    if (typeof parsed === 'object' && parsed !== null) return parsed;
    return null;
  } catch {
    return null;
  }
}

export { SHARED_KEYS };
